import React from 'react';
import './DocumentThumbnail.scss';

const DocumentThumbnail = ({ theme }) => {
  const styles = {
    page: {
      color: theme.colors.generatedPdf.page.backgroundColor,
    },
    titleBar: {
      backgroundColor: theme.colors.generatedPdf.titleBar.backgroundColor,
      color: theme.colors.generatedPdf.titleBar.color,
    },
    divider: {
      color: theme.colors.generatedPdf.divider.color,
    },
    premiumBox: {
      backgroundColor: theme.colors.generatedPdf.premiumBox.backgroundColor,
      color: theme.colors.generatedPdf.premiumBox.color,
    },
    benefitsHeader: {
      backgroundColor: theme.colors.generatedPdf.table.headerRow.backgroundColor,
      color: theme.colors.generatedPdf.table.headerRow.color,
      borderColor: theme.colors.generatedPdf.table.headerRow.borderColor,
    },
    benefitsBody: {
      backgroundColor: theme.colors.generatedPdf.table.bodyRow.backgroundColor,
      color: theme.colors.generatedPdf.table.bodyRow.color,
      borderColor: theme.colors.generatedPdf.table.bodyRow.borderColor,
    },
    footer: {
      backgroundColor: theme.colors.generatedPdf.footer.backgroundColor,
      color: theme.colors.generatedPdf.footer.color,
    },
  };

  return (
    <div className="whitelabel-document-preview">
      <div className="wl-thumbnail-container">
        <label>Documents</label>
        <div className="wl-thumbnail" style={styles.page}>
          <div className="wl-header wl-document-header">
            <div className="wl-logo-container wl-document-logo">
              <img
                className="wl-logo"
                alt="logo"
                src={theme.urls.documentLogo || theme.urls.logo}
              />

              <div className="wl-document-header-text">Policy Schedule</div>
            </div>
          </div>
          <div className="wl-title-bar" style={styles.titleBar}>
              <span className="wl-policy-number pull-left">
                Policy Reference: BND/JT/100001/2018
              </span>
            <span className="wl-policy-type pull-right">
                Annual Multi Trip Travel Insurance
              </span>
          </div>
          <div className="wl-document-body">
            <table className="wl-document-table">
              <colgroup>
                <col style={{ width: '18%' }}/>
                <col style={{ width: '82%' }}/>
              </colgroup>
              <tbody>
              <tr>
                <td className="wl-document-label">Dates of Cover:</td>
                <td>
                  1 Jan 2019 to 31 Dec 2019 both dates inclusive (
                  <strong> Max Trip Duration:</strong> 31)
                </td>
              </tr>
              </tbody>
            </table>
            <table className="wl-document-table">
              <colgroup>
                <col style={{ width: '18%' }}/>
                <col style={{ width: '27%' }}/>
                <col style={{ width: '22%' }}/>
                <col style={{ width: '33%' }}/>
              </colgroup>
              <tbody>
              <tr>
                <td className="wl-document-label">Issue Date:</td>
                <td>1 Nov 2018</td>
                <td className="wl-document-label">Destination:</td>
                <td>Worldwide</td>
              </tr>
              <tr>
                <td className="wl-document-label">Trip Type</td>
                <td>Annual Multi Trip</td>
                <td className="wl-document-label">Level of Cover:</td>
                <td>Beyond Travel Annual Silver</td>
              </tr>
              <tr>
                <td className="wl-document-label">Group Type:</td>
                <td>Individual</td>
                <td className="wl-document-label">Additional Options:</td>
                <td>Hazardous Activities B</td>
              </tr>
              </tbody>
            </table>
            <hr style={styles.divider}/>
            <table className="wl-document-table">
              <colgroup>
                <col style={{ width: '18%' }}/>
                <col style={{ width: '27%' }}/>
                <col style={{ width: '22%' }}/>
                <col style={{ width: '33%' }}/>
              </colgroup>
              <tbody>
              <tr>
                <td className="wl-document-label">Email:</td>
                <td>No email provided</td>
                <td className="wl-document-label">Telephone:</td>
                <td>07777 777 7777</td>
              </tr>
              </tbody>
            </table>
            <hr style={styles.divider}/>
            <table className="wl-document-table">
              <colgroup>
                <col style={{ width: '33%' }}/>
                <col style={{ width: '33%' }}/>
                <col style={{ width: '33%' }}/>
              </colgroup>
              <thead>
              <tr>
                <th>Insured Person(s)</th>
                <th>Medical Conditions</th>
                <th>Individual Options</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td className="caption">Mr Travelling Customer</td>
                <td className="caption">Asthma, Chest Infection</td>
                <td className="caption">None</td>
              </tr>
              </tbody>
            </table>
            <hr style={styles.divider}/>
            <div className="wl-document-premium" style={styles.premiumBox}>
              <table className="wl-document-table">
                <colgroup>
                  <col style={{ width: '75%' }}/>
                  <col style={{ width: '25%' }}/>
                </colgroup>
                <tbody>
                <tr>
                  <td className="wl-document-label">Premium:</td>
                  <td className="pull-right">£132.75</td>
                </tr>
                <tr>
                  <td className="wl-document-label">
                    Insurance Premium Tax @ 20.0%:
                  </td>
                  <td className="pull-right">£26.55</td>
                </tr>
                <tr>
                  <td className="wl-document-label">Admin Fees:</td>
                  <td className="pull-right">£13.00</td>
                </tr>
                <tr>
                  <td className="wl-document-label">
                    Total Payable (including IPT):
                  </td>
                  <td className="pull-right">£172.30</td>
                </tr>
                </tbody>
              </table>
            </div>
            <hr style={styles.divider}/>
            <div className="wl-document-benefits">
              <p className="wl-document-benefits-header">Schedule of Benefits</p>
              <table className="wl-document-table">
                <colgroup>
                  <col style={{ width: '50%' }}/>
                  <col style={{ width: '35%' }}/>
                  <col style={{ width: '15%' }}/>
                </colgroup>
                <thead>
                <tr>
                  <th style={styles.benefitsHeader}>Benefit</th>
                  <th style={styles.benefitsHeader}>Maximum Sum Insured</th>
                  <th style={styles.benefitsHeader}>Excess</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td style={styles.benefitsBody}>Cancellation</td>
                  <td style={styles.benefitsBody}>£3,000</td>
                  <td style={styles.benefitsBody}>£100</td>
                </tr>
                <tr>
                  <td style={styles.benefitsBody}>Curtailment</td>
                  <td style={styles.benefitsBody}>£3,000</td>
                  <td style={styles.benefitsBody}>£100</td>
                </tr>
                <tr>
                  <td style={styles.benefitsBody}>Emergency Medical</td>
                  <td style={styles.benefitsBody}>£5,000,000</td>
                  <td style={styles.benefitsBody}>£100</td>
                </tr>
                <tr>
                  <td style={styles.benefitsBody}>&nbsp;&nbsp;- Dental Expenses</td>
                  <td style={styles.benefitsBody}>£250</td>
                  <td style={styles.benefitsBody}>£100</td>
                </tr>
                <tr>
                  <td style={styles.benefitsBody}>&nbsp;&nbsp;- Hospital Benefit</td>
                  <td style={styles.benefitsBody}>£50 per 24 hours up to £500</td>
                  <td style={styles.benefitsBody}>nil</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="wl-footer" style={styles.footer}>
            <p>
              This is a policy schedule only. It does not include the full, conditions,
              definitions and exclusions which relate to this insurance. These are
              contained within the policy wording, a copy of which is available from our
              website www.justtravelcover.com.
            </p>
          </div>
        </div>
      </div>
    </div>
  );

};
export default DocumentThumbnail;
